<template>
  <router-view/>
</template>

<script setup>
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

const store = useStore();
const router = useRouter();

// 获取用户信息
const fetchUserInfo = async () => {
  if (store.getters.isLoggedIn) {
    try {
      await store.dispatch('getCurrentUser');
    } catch (error) {
      console.error('获取用户信息失败:', error);
    }
  }
};

// 页面加载时获取用户信息
onMounted(() => {
  fetchUserInfo();
});

// 路由变化时获取用户信息
router.afterEach(() => {
  fetchUserInfo();
});
</script>

<style lang="less">
/* 全局响应式设计 */
html, body {
  height: 100%;
  margin: 0;
  padding: 0;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

#app {
  height: 100%;
  min-height: 100vh;
  background-color: #000;
  color: #fff;
}

/* 响应式断点 */
@media screen and (max-width: 576px) {
  /* 小屏手机适配 */
  html {
    font-size: 12px;
  }
}

@media screen and (min-width: 577px) and (max-width: 768px) {
  /* 大屏手机适配 */
  html {
    font-size: 14px;
  }
}

@media screen and (min-width: 769px) and (max-width: 1024px) {
  /* 平板适配 */
  html {
    font-size: 16px;
  }
}

@media screen and (min-width: 1025px) {
  /* 桌面端适配 */
  html {
    font-size: 18px;
  }
}
</style>
